<template>
    <v-icon color="grey-darken-1" class="mx-1">
        edit
    </v-icon>
</template>

<script>
    export default {
        name: 'EditIcon',
    }
</script>

<style scoped>

</style>